import { render } from "./how-it-works.vue?vue&type=template&id=dc2b3de0&scoped=true"
import script from "./how-it-works.vue?vue&type=script&lang=js"
export * from "./how-it-works.vue?vue&type=script&lang=js"

import "./how-it-works.vue?vue&type=style&index=0&id=dc2b3de0&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc2b3de0"]])

export default __exports__